const SidebarInvestigationDetails = (id) => ({
  id: `investigation-${id}`,
  title: "Investigation",
  componentKey: "InvestigationSidebarContent",
  props: { investigationId: id }
});
export default SidebarInvestigationDetails;
